var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEstudios(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66.7 69.1",
    style: {
      enableBackground: "new 0 0 66.7 69.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2_00000101804559604452446560000006863521753046868380_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.8,14.3V8.2c0-0.9-0.7-1.6-1.6-1.6H37.9L59.8,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.1,6.6c-1,0-1.8,0.8-1.8,1.8c0,0,0,0,0,0v4.5c0.4-0.2,0.8-0.3,1.2-0.3h1.7l2.1-6H11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,1.9l-3.8,10.7h11.9c1.6,0,2.9,1.3,2.9,2.9v5.9h33.5c0.7,0,1.4,0.1,2,0.4l1.4-4.2c0.3-0.9-0.1-1.9-1-2.2 L19.6,0.2C18.1-0.3,16.5,0.4,16,1.9z M59.5,22c-11-0.1-21.9-0.2-32.9-0.4l-0.2-5.9c-0.2-0.5-0.6-1-1.1-1.4c-1-0.8-2.2-0.8-3-0.9 c-1.9-0.1-3.9-0.2-6.4-0.3l2.4-6.9c0-0.1,0.2-1,1-1.4c0.9-0.5,1.7,0,1.8,0C42.9,12,58.6,17.1,59.6,17.4c0.1,0,0.4,0.1,0.7,0.4 c0.4,0.5,0.3,1.3,0,2C60,20.5,59.8,21.3,59.5,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.6,21.4H27.1v-5.9c0-1.6-1.3-2.9-2.9-2.9H10.5c-1.6,0-2.9,1.3-2.9,2.9c0,0,0,0,0,0v5.9H6.1 c-3.4,0-6.1,2.7-6.1,6.1v35.4C0,66.3,2.7,69,6.1,69h54.5c3.4,0,6.1-2.7,6.1-6.1V27.5C66.7,24.1,64,21.4,60.6,21.4z M61.2,56.4v3.1 c0,2.5-2.1,4.6-4.6,4.6H10.1c-2.5,0-4.6-2.1-4.6-4.6c0,0,0,0,0,0V29.6c0-2.5,2.1-4.6,4.6-4.6h2.3v-5.2c0-1.2,1-2.2,2.2-2.2h6.1 c1.2,0,2.2,1,2.2,2.2V25h33.7c2.5,0,4.6,2.1,4.6,4.6L61.2,56.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstudios);
export default __webpack_public_path__ + "static/media/Estudios.41a1a3dd1688162549076dded3637be4.svg";
export { ForwardRef as ReactComponent };